import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { Nav } from './Nav';
import { TopBar } from './TopBar';
import { media, theme, color } from '../theme';
import { useConfig } from '../utils';
import logo from '../img/logo.png';
import logo2x from '../img/logo@2x.png';
import logo3x from '../img/logo@3x.png';

export function Header() {
  const { title } = useConfig();

  return (
    <Head>
      <div className="container" style={{ height: theme.headerHeight }}>
        <Link id="logo" to="/">
          <img src={logo} srcSet={`${logo2x} 2x, ${logo3x} 3x`} width={theme.headerLogoSize} alt={`${title} logo`} />
          <h1>{title}</h1>
        </Link>
        <Nav />
      </div>
      <TopBar />
    </Head>
  );
}

const Head = styled.header`
  position: ${theme.headerPosition};
  top: 0;
  right: 0;
  left: 0;
  height: ${theme.headerContainerHeight};
  z-index: 500;
  background: ${theme.headerBackgroundColor};
  box-shadow: 0 -10px 20px 0 ${theme.headerBoxShadowColor};
  display: flex;
  flex-direction: column;
  > div {
    display: flex;
    justify-content: space-between;
    order: 1;
  }
  #logo {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover h1, &:focus h1 {
      /* text-decoration: underline; */
      color: ${color.gold};
    }
    &:active {
      transform: translateY(1px);
    }
    img {
      margin-right: 0.75rem;
      height: 40px;
      width: 40px;
      @media ${media.phoneM} {
        height: ${theme.headerLogoSize};
        width: ${theme.headerLogoSize};
      }
    }
    
    h1 {
      margin: 0;
      font-size: 1rem;
      line-height: 1.25;
      font-weight: 600;
      position: relative;
      top: -0.025em; /* font-family specific */
      text-shadow: 0 1px 0 rgba(255,255,255,0.5);
      letter-spacing: 0.025em;

      @media ${media.phoneM} {
        font-size: 1.2rem;
      }

      @media ${media.tabletS} {
        /* font-weight: 600; */
        text-shadow: none;
        letter-spacing: 0;
      }
    }
  }
  + main {
    padding-top: ${theme.headerContainerHeight};
  }
`;
